// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__1XLvz","rotation":"loader_rotation__UiHF0"};